import { Injectable, computed, signal } from '@angular/core';

export interface LoadingOptions {
  title?: string;
  message?: string;
}

/**
 * The search loader state (run 24, Levan 11.10.2026: no full-screen sky over the page any more). show() / hide() keep their meaning for every
 * search form; what they drive now is the thin themed line above the results (app-search-line-loader) - the page stays readable and usable.
 * A page that placed its own line registers it; while none is on screen the app shell draws a fallback line, so no search runs unseen.
 */
@Injectable({ providedIn: 'root' })
export class LoadingWindowService {
  readonly #active = signal(false);
  readonly #pageLoaders = signal(0);

  readonly active = this.#active.asReadonly();
  readonly hasPageLoader = computed(() => this.#pageLoaders() > 0);

  public get isVisible() {
    return this.#active();
  }
  toggle(toggle = !this.#active(), _options?: LoadingOptions): boolean {
    this.#active.set(toggle);
    return toggle;
  }
  show(options?: LoadingOptions) {
    if (this.#active()) return;
    return this.toggle(true, options);
  }
  hide() {
    return this.toggle(false);
  }

  /** a line placed on the page; call the returned function when it leaves */
  registerPageLoader(): () => void {
    this.#pageLoaders.update((n) => n + 1);
    let released = false;
    return () => {
      if (released) return;
      released = true;
      this.#pageLoaders.update((n) => Math.max(0, n - 1));
    };
  }
}
